<template>
<Fieldset  :legend="category.name"  :toggleable="true" class="mt-2 mb-2" :collapsed="true" @toggle="toggle">
<ClickEditInputText  title="Kategori İsmi" :value="category.name" :valkey="category.id" @dataChanged="categoryChanged"></ClickEditInputText>

<div  v-for="language in languages" :key="language.id">
<ClickEditInputText  v-for="translation in category.translations" :key="translation.id" :title="language.name+ ' İsmi'" :value="translation.translation" :valkey="translation.id" @dataChanged="optiontranslationChanged" v-show="translation.language_id == language.id"></ClickEditInputText> 
</div>

<div class="pl-1">
 <hr>
<h4 class="text-primary">Alt Kategoriler</h4>
<CategoryBrandAttribute v-for="subcategory in subcategories" :category="subcategory" :key="subcategory.id" :languages="languages"   @dataRenewed="renewData"></CategoryBrandAttribute>

<br/>
<ClickAddInputText  title="Yeni Ekle"  valkey="new_phrase" @newAdded="newCategoryAdded"></ClickAddInputText>

</div>

<div class="flex align-items-center justify-content-end mb-6">
    
 <Button label="Sil" icon="pi pi-check" class="p-button-danger p-button-sm p-button-outlined" @click="deleteCategory(category.id)"/>
</div>

</Fieldset>	
</template>

<script>
import CategoryBrandAttribute from "./CategoryBrandAttribute"
export default {

  name: 'CategoryBrandAttribute',
  components:{CategoryBrandAttribute},
  props:["category","languages"],
  data () {
    return {
    	subcategories:[],
    }
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.renewData()
  		}
  	}
  },
  methods:{
  	toggle(event)
  	{
  		console.log(event)
  		if(!event.value)
  		{
  			this.getSubs()
  		}
  	},
  	async getSubs()
  	{
  		console.log("getSubs")
  		this.subcategories = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute_sub_categories/"+this.category.id)
  	},
  	categoryChanged(data)
  	{		
		let formdata = new FormData()
		formdata.append("name",data.value)
		this.generalSubmission(formdata,"custom_attribute/update_category/"+data.key,this.renewData)
  	},
  	renewData(response)
  	{
  		this.getSubs()
  		this.$emit("dataRenewed")
  	},
  	optiontranslationChanged(data)
  	{

		let formdata = new FormData()
		formdata.append("data",data.value)
		this.generalSubmission(formdata,"custom_attribute/update_category_translation/"+data.key,this.renewData)
  	},
  	newCategoryAdded(data)
    {
      let formdata = new FormData()
      formdata.append("name",data.value)
      formdata.append("parent",this.category.id)
      this.generalSubmission(formdata,"custom_attribute/store_category/"+this.category.customattribute_id,this.renewData)
    },
    deleteCategory(id)
  	{
  		this.deleteItem("custom_attribute_category",id)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>